import styled from 'styled-components'

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const DownloadAllButton = styled.button`
  cursor: pointer;
  width: 10rem;
  height: 2rem;
  background-color: ${(props) => props.theme.colors.primaryColor300};
  border: none;
  border-radius: 4px;
  color: ${(props) => props.theme.colors.black};
  &:hover {
    background-color: ${(props) => props.theme.colors.primaryColor100};
  }
`

export const StyledTbody = styled.tbody`
  color: ${(props) => props.theme.colors.white};
`

export const StyledTd = styled.td`
  padding: 0.5rem 1rem;
  text-align: ${(props) => props.align};
`

export const PageInput = styled.input`
  background-color: transparent;
  height: 30px;
  align-items: center;
  text-align: center;
  font-weight: 700;
  color: white;
  padding-left: 5px;
  padding-top: 4px;
  padding-right: 1px;
  border: none;
  width: 100%;
  outline: none;
  &:focus {
    color: #85f6f4;
  }
`

export const SelectPageEntries = styled.select`
  background-color: transparent;
  color: white;
  height: 2rem;
  margin-right: 10px;
  font-size: 0.8rem;
  border-radius: 4px;
  border: 1px solid #85f6f4;
  padding: 0 0.5rem;

  &:focus {
    outline: none;
    box-shadow: none;
    color: #85f6f4;
  }
`
